import { useState } from "react"

export default function ManufacturerAccordion() {
    const [accordionOpen, setAccordionOpen] = useState(true)
    const toggleAccordion = () => {
        setAccordionOpen(prev => !prev)
    }

    return (
        <div className="MuiPaper-root MuiAccordion-root filter-product-accordion Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded">
            <button className="styles_accordionHeader__xUFrY" onClick={toggleAccordion}>
                <p>Nhà sản xuất</p>
                <span className={[accordionOpen ? "styles_buttonExpand__QQLBp styles_buttonExpanded__jSTHs" : "styles_buttonExpand__QQLBp"].join(" ")}>
                    <svg
                        className="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >
                        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>
                </span>
            </button>

            {accordionOpen && (
                <div
                    className="MuiCollapse-root MuiCollapse-entered"
                    style={{ minHeight: "0px" }}
                >
                    <div className="MuiCollapse-wrapper">
                        <div className="MuiCollapse-wrapperInner">
                            <div role="region">
                                <div
                                    className="MuiAccordionDetails-root accordion-detail"
                                    style={{ display: "block" }}
                                >
                                    <div className="styles_containerList__c3d5v styles_itemList__qvTM4">

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Sanofi</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>GSK</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>DHG Pharma</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Vidipha</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Mekophar</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Khánh Hòa - Khapharco</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Everpharma</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Bayer Pharma</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Organon</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Stellapharm</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>US Pharma USA</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>OPC</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Rohto-Mentholatum</span>
                                            </button>
                                        </div>

                                        <div style={{ width: "100%" }}>
                                            <button className="styles_item__rQ1Ka">
                                                <span>Trường Sơn</span>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
